import React, { isValidElement } from "react";

import { Cell } from "@tanstack/react-table";

import { GenericObject } from "src/api/flowTypes";
import { DataRow, NodeExecutionMetadata } from "src/api/types";

export type SuccessResultDataAndAuxRow = {
  index: number;
  type: "success" | "success_mismatch" | "success_match";
  data: DataRow;
  auxData: DataRow;
  expectedOutputData?: DataRow;
  expectedOutputKeysMismatch?: string[];
  nodeExecutionMetadata?: NodeExecutionMetadata;
  decisionId?: string;
};

export type PendingResultDataAndAuxRow = {
  index: number;
  type: "pending";
  data: DataRow;
  nodeExecutionMetadata?: NodeExecutionMetadata;
  decisionId?: string;
};

export type ResultDataAndAuxRowV2 =
  | SuccessResultDataAndAuxRow
  | PendingResultDataAndAuxRow
  | {
      index: number;
      type: "ignored";
      data: DataRow;
      auxData: DataRow;
      nodeExecutionMetadata?: NodeExecutionMetadata;
      decisionId?: string;
      errorMessage?: string;
      errorOriginNodeId?: string;
    }
  | {
      index: number;
      type: "failure";
      errorMessage: string;
      errorOriginNodeId: string | undefined;
      data: DataRow;
      auxData: DataRow;
      nodeExecutionMetadata?: NodeExecutionMetadata;
      provenance?: Record<string, GenericObject>;
      decisionId?: string;
    };

export type ResultsDataStatus = ResultDataAndAuxRowV2["type"];

export type CellContent<T = GenericObject> = Cell<T, unknown>;

export const isReactNode = (c: unknown): c is React.ReactElement =>
  isValidElement(c);
